import { bp } from 'theme';

import { getViewportSize } from './getViewportSize';

export type ViewportBreakpoint = 'xs' | 'sm' | 'md' | 'lg';

export const viewportBreakpointArray: ViewportBreakpoint[] = [
  'xs',
  'sm',
  'md',
  'lg',
];

export function getViewportBreakpoint() {
  const { viewportWidth } = getViewportSize();

  const breakpointIndex = bp.reduce(
    (acc, point, index) => (viewportWidth >= point ? index : acc),
    0
  );

  return viewportBreakpointArray[breakpointIndex];
}
